import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between mt-6" }
const _hoisted_2 = { class: "mt-6" }

import { ref } from "vue";
import { storeToRefs } from "pinia";

import TitleHeader from "@/components/TitleHeader.vue";
import ParentChildTable from "@/components/ParentChildTable.vue";

import api from "@/api/api";
import { Student } from "@/types";
import { useUserStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'MyChildren',
  async setup(__props) {

let __temp: any, __restore: any

const { user } = storeToRefs(useUserStore());

const students = ref([] as Student[]);

students.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.students.listStudentsByParent(user.value.id))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.students;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('my-children')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ParentChildTable, { students: students.value }, null, 8, ["students"])
    ])
  ], 64))
}
}

})